import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/routes/_layout/AppLayout";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { LoginPage } from "@/routes/auth/LoginPage";
import { CallbackPage } from "@/routes/auth/CallbackPage";
import { WrongAppPage } from "@/routes/auth/WrongAppPage";
import { OverviewPage } from "@/routes/overview/OverviewPage";
import { ExposureInsightsPage } from "@/routes/exposure-insights/ExposureInsightsPage";
import { ExposureIncidentsPage } from "@/routes/exposure-incidents/ExposureIncidentsPage";
import { IncidentsListPage } from "@/routes/incidents/IncidentsListPage";
import { IncidentDetailPage } from "@/routes/incidents/IncidentDetailPage";
import { PersonnelPage } from "@/routes/personnel/PersonnelPage";
import { PersonnelDetailPage } from "@/routes/personnel/PersonnelDetailPage";
import { ReportsPage } from "@/routes/reports/ReportsPage";
import { CompliancePage } from "@/routes/compliance/CompliancePage";
import { SopCompliancePage } from "@/routes/sop-compliance/SopCompliancePage";
import { SopDocumentsPage } from "@/routes/sop-documents/SopDocumentsPage";
import { SopDocumentReviewPage } from "@/routes/sop-documents/SopDocumentReviewPage";
import { RetentionPage } from "@/routes/retention/RetentionPage";
import { AuditLogPage } from "@/routes/audit-log/AuditLogPage";
import { DevicesPage } from "@/routes/devices/DevicesPage";
import { GatewayFleetPage } from "@/routes/gateway-fleet/GatewayFleetPage";
import { ApparatusPage } from "@/routes/apparatus/ApparatusPage";
import { SettingsPage } from "@/routes/settings/SettingsPage";
import { SandboxPage } from "@/routes/sandbox/SandboxPage";
import { useAuth } from "@/auth/AuthProvider";
import { isSalesOnly } from "@/lib/permissions";
import { usePageTracking } from "@/analytics";

/** A sales-only login has no dashboard — its home is the sandbox form. */
function HomeRedirect() {
  const { identity } = useAuth();
  return (
    <Navigate to={isSalesOnly(identity?.role) ? "/sandbox" : "/overview"} replace />
  );
}

export function App() {
  usePageTracking();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<CallbackPage />} />
      <Route path="/wrong-app" element={<WrongAppPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route
            path="/exposure-insights"
            element={<ExposureInsightsPage />}
          />
          <Route
            path="/exposure-incidents"
            element={<ExposureIncidentsPage />}
          />
          <Route path="/incidents" element={<IncidentsListPage />} />
          <Route path="/incidents/:id" element={<IncidentDetailPage />} />
          <Route path="/personnel" element={<PersonnelPage />} />
          <Route path="/personnel/:id" element={<PersonnelDetailPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/gateway-fleet" element={<GatewayFleetPage />} />
          <Route path="/apparatus" element={<ApparatusPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/sop-compliance" element={<SopCompliancePage />} />
          <Route path="/sop-documents" element={<SopDocumentsPage />} />
          <Route path="/sop-documents/:id" element={<SopDocumentReviewPage />} />
          <Route path="/retention" element={<RetentionPage />} />
          <Route path="/audit-log" element={<AuditLogPage />} />
          <Route path="/sandbox" element={<SandboxPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}
